<div class="w-full h-[48px] flex items-center sticky top-0 z-10 bg-white border-b-1 border-b-primary-border border-solid">
  <div class="flex items-center justify-between w-full">
    <ng-container *ngIf="!isGlobal; else globalTemplate">
      <div data-type="storage-info" class="flex items-center">
        <button
          nz-button
          nz-dropdown
          nzType="text"
          nzTrigger="click"
          nzPlacement="bottomLeft"
          [nzDropdownMenu]="menu"
          class="flex items-center gap-[6px] rounded-sm p-16 text-sm leading-lg text-primary-text"
          [attr.data-intercom-target]="intercomTarget + '-storage-dropdown-button'"
          [attr.data-testid]="'system-selector-trigger'"
        >
          <ng-container *ngIf="selectedStorage$ | async as selectedStorage; else loadingTemplate">
            <twaice-fe-svg-icon name="server" source="tabler" size="16px"></twaice-fe-svg-icon>
            <span class="mt-2 ml-2">{{ selectedStorage?.systemName }}</span>
          </ng-container>
          <ng-template #loadingTemplate>
            <div class="flex items-center justify-center gap-8">
              <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
              <span class="text-sm">Loading…</span>
            </div>
          </ng-template>
          <twaice-fe-svg-icon name="chevron-down" source="tabler" size="16px" class="mt-1"></twaice-fe-svg-icon>
        </button>

        <twaice-fe-time-selector
          *ngIf="
            (isPerformanceManagerSolution ||
              isWarrantyTracker ||
              isDataExplorerSolution ||
              isPenaltyRiskSolution ||
              isAlertsSolution ||
              isBMSAlertsSolution) &&
            !isOnDataExplorerLanding()
          "
          [showFullYearSelector]="isWarrantyTracker"
          [isDataExplorerSolution]="isDataExplorerSolution"
          [isWarrantySolution]="isWarrantyTracker"
        />

        <twaice-fe-timezone-indicator class="ml-8" />
      </div>
    </ng-container>

    <div
      *ngIf="!isFleet && !isGlobal"
      data-type="metadata"
      class="flex items-center gap-16 text-sm px-13 mr-8"
      [attr.data-intercom-target]="intercomTarget + '-energy-storage-info'"
    >
      <div class="flex flex-col md:flex-row md:items-center md:gap-8 leading-base text-primary-text">
        <div *ngIf="systemIngestionStatisticsLastSeenIsLoading$ | async; else dataContent" class="flex items-center gap-8">
          <twaice-fe-svg-icon name="wifi" source="tabler" color="#828794" size="20px"> </twaice-fe-svg-icon>
        </div>

        <ng-template #dataContent>
          <ng-container [ngSwitch]="connectionStatus$ | async">
            <div
              *ngSwitchCase="'not-onboarded'"
              class="flex gap-4 items-center"
              nz-tooltip
              [nzTooltipTitle]="notOnboardedTooltipTemplate"
              nzTooltipPlacement="bottom"
            >
              <twaice-fe-svg-icon name="wifi-off" source="tabler" classList="text-tertiary-text" size="20px">
              </twaice-fe-svg-icon>
            </div>
            <div
              *ngSwitchCase="'stale'"
              class="flex gap-4 items-center"
              nz-tooltip
              [nzTooltipTitle]="tooltipTemplate"
              nzTooltipPlacement="bottom"
            >
              <twaice-fe-svg-icon name="wifi-off" source="tabler" color="#cf1423" size="20px"> </twaice-fe-svg-icon>
            </div>
            <div
              *ngSwitchDefault
              class="flex items-center gap-8"
              nz-tooltip
              [nzTooltipTitle]="tooltipTemplate"
              nzTooltipPlacement="bottom"
            >
              <twaice-fe-svg-icon name="wifi" source="tabler" color="#15cd76" size="20px"> </twaice-fe-svg-icon>
            </div>
          </ng-container>
        </ng-template>
      </div>

      <ng-template #tooltipTemplate>
        <div class="flex flex-col gap-8 p-8">
          <div class="flex gap-4">
            <span class="text-secondary-text">Last data:</span>
            <span class="text-primary-text">{{
              dateFormattingService.formatAsTimeAgoBasedOnDateWithCorrectTimeZone(lastSeenTimestamp$ | async)
            }}</span>
          </div>
          <button
            nz-button
            nzSize="small"
            (click)="fetchSystemIngestionStatistics()"
            [nzLoading]="systemIngestionStatisticsLastSeenIsLoading$ | async"
            class="flex items-center justify-center gap-4"
          >
            <twaice-fe-svg-icon name="reload" source="tabler" size="14px"></twaice-fe-svg-icon>
            <span>Refresh</span>
          </button>
        </div>
      </ng-template>

      <ng-template #notOnboardedTooltipTemplate>
        <div class="flex flex-col gap-8 p-8">
          <span class="text-primary-text">System not onboarded. No data available.</span>
        </div>
      </ng-template>

      <button
        (click)="openChatDrawer()"
        nz-popover
        nzPopoverContent="System Notes"
        nzPopoverPlacement="bottom"
        class="flex items-center justify-center"
      >
        <twaice-fe-svg-icon source="tabler" name="messages" width="16px" height="16px" />
      </button>

      <twaice-fe-svg-icon
        name="binary-tree-2"
        source="tabler"
        class="cursor-pointer"
        size="16px"
        (click)="openMetadataDialog()"
        nz-popover
        nzPopoverContent="System Metadata"
        nzPopoverPlacement="bottom"
        [attr.data-intercom-target]="intercomTarget + '-storage-metadata-button'"
      />

      <ng-container *ngIf="selectedStorage$ | async as selectedStorage">
        <div class="flex flex-col md:flex-row md:items-center md:gap-8 leading-base text-primary-text">
          <span class="text-secondary-text">Cycles last 30 days</span>
          <twaice-fe-data-display
            numberFormat="1.0-0"
            [value]="selectedStorage?.healthSummary?.throughput?.last30DaysEfc ?? '--'"
          ></twaice-fe-data-display>
        </div>

        <div class="flex flex-col md:flex-row md:items-center md:gap-8 leading-base text-primary-text">
          <span class="text-secondary-text">Total cycles</span>
          <twaice-fe-data-display
            numberFormat="1.0-0"
            [value]="selectedStorage?.healthSummary?.throughput?.totalEfc ?? '--'"
          ></twaice-fe-data-display>
        </div>

        <div class="flex flex-col md:flex-row md:items-center md:gap-8 leading-base">
          <span class="text-secondary-text">Min. SoH</span>
          <twaice-fe-data-display
            numberFormat="1.0-0"
            measurand="%"
            [value]="selectedStorage?.healthSummary?.soh?.min ?? '--'"
          ></twaice-fe-data-display>
        </div>

        <div class="flex flex-col md:flex-row md:items-center md:gap-8 leading-base">
          <span class="text-secondary-text">Max. SoH</span>
          <twaice-fe-data-display
            numberFormat="1.0-0"
            measurand="%"
            [value]="selectedStorage?.healthSummary?.soh?.max ?? '--'"
          ></twaice-fe-data-display>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul class="max-h-[400px] overflow-y-auto rounded-lg mt-[-9px] p-0" nz-menu>
    <ng-container *ngIf="(storages$ | async)?.length > 0; else loadingTemplate">
      <div class="px-16 py-16 sticky top-0 bg-white z-10" *ngIf="(storages$ | async)?.length > TOTAL_STORAGE_COUNT">
        <input class="p-8" nz-input placeholder="Search ..." [(ngModel)]="inputValue" (input)="handleSearchInput($event)" />
      </div>
      <li
        nz-menu-item
        *ngFor="let storage of filteredStorages$ | async"
        class="hover:bg-gray-100 p-0"
        (click)="onRowSelected(storage)"
      >
        <ng-container *ngIf="!isFleet; else fleetTemplate">
          <div class="px-24 py-16 grid grid-cols-[1fr_auto_auto_auto] gap-16">
            <span class="text-sm font-semibold leading-lg w-[128px]">{{ storage?.systemName }}</span>
            <span class="text-tertiary-text text-xs leading-lg w-[128px]">{{ getStorageLocation(storage.bessMetadata) }}</span>
            <span class="text-tertiary-text text-xs leading-lg w-[128px]">
              @if (storage.bessMetadata?.storageTimezone) {
                {{ now$ | async | twDate: 'HH:mm' : storage.bessMetadata.storageTimezone }}
                {{ getTimezoneOffsetFromUtc(storage.bessMetadata.storageTimezone) }}
              } @else {
                --
              }
            </span>
            <span class="text-tertiary-text text-xs leading-lg w-[128px]"
              >{{
                storage?.bessMetadata?.nameplateEnergyCapacityMwh
                  ? (storage?.bessMetadata?.nameplateEnergyCapacityMwh | number: '1.0-0') + ' MWh'
                  : '--'
              }}
              |
              {{
                storage?.bessMetadata?.nameplatePowerMw
                  ? (storage?.bessMetadata?.nameplatePowerMw | number: '1.0-0') + ' MW'
                  : '--'
              }}</span
            >
          </div>
        </ng-container>

        <ng-template #fleetTemplate>
          <div class="px-24 py-16 flex items-center gap-16 bg-white">
            <span class="text-sm font-semibold leading-lg">{{ storage?.systemName }}</span>
          </div>
        </ng-template>
      </li>
    </ng-container>
    <ng-template #loadingTemplate>
      <div class="flex items-center justify-center gap-8">
        <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
        <span class="text-lg">Loading…</span>
      </div>
    </ng-template>
  </ul>
</nz-dropdown-menu>

<ng-template #globalTemplate>
  <div class="flex items-center gap-8 p-16 pl-[13px] text-sm leading-lg text-primary-text">
    <twaice-fe-svg-icon name="icon_server"></twaice-fe-svg-icon> All Storages
  </div>
</ng-template>
